import React from "react";
import {
  FaSearch,
  FaDraftingCompass,
  FaCode,
  FaShieldAlt,
  FaRocket,
} from "react-icons/fa";

const steps = [
  {
    title: "Discovery & Requirement Analysis",
    desc: "Understanding business needs, goals, and technical feasibility.",
    icon: FaSearch,
  },
  {
    title: "Solution Architecture & UX Design",
    desc: "Crafting scalable architecture with intuitive user experience.",
    icon: FaDraftingCompass,
  },
  {
    title: "Development (AI, Blockchain, Web3)",
    desc: "Building secure and high-performance applications.",
    icon: FaCode,
  },
  {
    title: "Testing & Security Audits",
    desc: "Ensuring bug-free and secure deployment.",
    icon: FaShieldAlt,
  },
  {
    title: "Deployment & Scaling",
    desc: "Launch, monitor, and scale your solution efficiently.",
    icon: FaRocket,
  },
];

function ProcessSection() {
  return (
    <div className="process-section">
      <div className="container">
        <div className="row align-items-center">
          {/* LEFT SIDE (IMAGE) */}
          <div className="col-lg-6">
            <div className="process-image">
              <img
                src="assets/img/thumb/crafting_smarter_ai_image.jpg"
                alt="AI Process"
              />
            </div>
          </div>

          {/* RIGHT SIDE (CONTENT) */}
          <div className="col-lg-6">
            <h2 className="title mb-5">
              Crafting Smarter AI Through Our Process
            </h2>

            {steps.map((step, i) => {
              const Icon = step.icon;
              return (
                <div className="process-item" key={i}>
                  <div className="icon-box">
                    <Icon />
                  </div>

                  <div>
                    <h5>{step.title}</h5>
                    <p>{step.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessSection;
